import { Box, Button, styled, ToolbarProps } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import TheGuarantorsLogo from '../../../assets/images/TheGuarantors_Logo.svg';
import useDeviceSize from '../../../helpers/hooks/useDeviceSize';
import BackIcon from '../../Icons/BackIcon';

const LeftSection = styled(Box)({
  flex: 1,
  display: 'flex',
  alignItems: 'center'
})

const CenterSection = styled(LeftSection)({
  flex: 2,
  justifyContent: 'center'
})

const RightSection = styled(LeftSection)({})

export type HeaderV1Props = {
  title?: string;
  logoImage?: string;
  backButtonAction?: (() => void) | null;
  fullHeight?: boolean;
}

type ToolbarStyledProps = ToolbarProps & { isPartHeightOrDesktop: boolean };

const ToolbarStyled = styled(Toolbar, {
  shouldForwardProp: (propName: string) =>
    propName !== 'isPartHeightOrDesktop',
})<ToolbarStyledProps>(({ isPartHeightOrDesktop }) => ({
  borderRadius: isPartHeightOrDesktop ? '8px' : '0px',
  backgroundColor: 'white',
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  boxShadow: '4px 16px 32px rgba(0, 0, 0, 0.08)',
  margin: isPartHeightOrDesktop ? '10px' : '0px',
}));

const Header = (props: HeaderV1Props) => {
  const { fullHeight = false, backButtonAction } = props;
  const { desktop } = useDeviceSize();

  return (
    <ToolbarStyled isPartHeightOrDesktop={desktop || !fullHeight}>
      <LeftSection>
        {backButtonAction && (
          <Button
            size="small"
            variant="text"
            startIcon={<BackIcon size={desktop ? 40 : 30} />}
            onClick={backButtonAction}
            sx={{
              padding: '2px 4px !important',
            }}
          >
            {desktop && <span style={{ marginLeft: '8px' }}>Back</span>}
          </Button>
        )}
      </LeftSection>
      <CenterSection>
        <img height="30px" alt="" src={TheGuarantorsLogo} />
      </CenterSection>
      <RightSection />
    </ToolbarStyled>
  );
};


export default Header;
